import { tsIoValidate } from "../../../../utils/general/generalUtils"
import {
    ManufacturerDevicesData,
    IManufacturerDevicesData,
} from "../../types/manufacturerInterface/manufacturerHomepageTypes"

export const manufacturerHomepageMapper = {
    /**
     * Maps the response from the Manufacturer Homepage API to the IManufacturerDevicesData interface.
     * @param response - The response from the API.
     * @returns The mapped object of type IManufacturerDevicesData.
     */
    mapManufacturerDevicesData: (
        response: unknown
    ): IManufacturerDevicesData => {
        const res = tsIoValidate<IManufacturerDevicesData>(
            ManufacturerDevicesData,
            response,
            "Error mapping Manufacturer Homepage Devices Data"
        )
        return res
    },
}
